



























import {Component, Vue, Prop} from 'vue-property-decorator'
import Link from "@/components/External/Link.vue";
import api from "@/api/api";
import {constants} from "@/helpers/constants"

@Component({
  components: { Link }
})
export default class NewsList extends Vue {
  @Prop({required: true}) type!: number
  private linkList: object[] = []
  private isOpenInNewTab = 1
  public articleType = constants.articleType

  created(){
    this.getLinkList()
    // console.log('link', this.linkList)
  }

  async getLinkList(){
    const COUNT = this.type === this.articleType.YTPlay? 5: 7
    const TYPE = this.type
    try{
      const res = await api.getCMSArticle(TYPE, COUNT)
      this.linkList = res.data
    }catch (e){
      console.log(e)
    }
  }
}
